import o from"./global.js";import a from"./define-global-property.js";var e=o,l=a,r="__core-js_shared__",t=e[r]||l(r,{}),d=t;export{d as default};
